<template>
  <!-- 转库唛头打印 -->
  <div>
    <div class="main" v-for="(item, index) in printData" :key="index" style="page-break-after:always;">
      <div class="content">
        <div class="top">
          {{ item.realname }}
        </div>
        <div class="box">
          {{ item.move_sn }} - {{ item.box_no }}
        </div>
        <div class="row-name">
          <div class="item">
            <div class="label">业务</div>
            <div class="value">{{ item.y_admin_realname }}</div>
          </div>
          <div class="item">
            <div class="label">配货</div>
            <div class="value">{{ item.p_admin_realname }}</div>
          </div>
          <div class="item">
            <div class="label">重量</div>
            <div class="value">{{ item.weight }}KG</div>
          </div>
          <div class="item">
            <div class="label">尺寸</div>
            <div class="value">{{ item.attr }}CM</div>
          </div>
          <div class="item">
            <div class="label">打印时间</div>
            <div class="value">{{ getDate() }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getDate } from '@/utlis/date'
export default {
  props: {
    printData: { type: Array }
  },
  data() {
    return {
      getDate
    };
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
.main {
  width: 1181px;
  height: 1772px;
  background: #fff;
  padding: 48px;
  box-sizing: border-box;
  color: #000000 !important;

  div {
    box-sizing: border-box;
  }

  .content {
    width: 1061px;
    height: 1652px;
    border: 4px solid #000000;
    padding-bottom: 100px;

    .top {
      padding: 100px 0;
      box-sizing: border-box;
      background-color: #000;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 60px;
      font-weight: 600;
    }

    .box {

      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 60px;
      font-weight: 600;
      padding: 60px 0;
      border-bottom: 4px solid #000;
    }



    .row-name {
      padding: 45px 30px;

      .item {
        display: flex;

        padding: 45px;
        justify-content: space-between;

        .label {
          font-size: 60px;
        }

        .value {
          margin-top: 20px;
          font-size: 60px;
          font-weight: 600;
        }
      }

    }


  }
}
</style>
